import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closePopup } from '../../actions/uiActions'
import ImageGallery from '../utilities/ImageGallery'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';

class SheetViewPopup extends React.Component {

    state = {

    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 27) {
            this.props.closePopup()
        }
    }

    render() {
        let imageArr = []
        this.props.sheets.forEach(x => imageArr.push({ original: `data:image/jpeg;base64,${x.sheetImage.imageBytes}`, thumbnail: `data:image/jpeg;base64,${x.sheetImage.imageBytes}` }))
        return (<Dialog open={true} onClose={this.handleClick} className="bigSlidePopup">
            <DialogTitle>
                <span className="closePopupLoader" onClick={this.props.closePopup}>
                    <CloseIcon />
                </span>
            </DialogTitle>
            <DialogContent>
                <div className="slideCenterBox" >
                    <ImageGallery items={imageArr} showPlayButton={false} lazyLoad={true} infinite={false} showFullscreenButton={false} />
                </div>
            </DialogContent>
        </Dialog>)
    }

}


function mapStateToProps(state) {
    return {
        sheets: state.presentations.present.presentationView.sheets,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SheetViewPopup)